// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.
// @ts-nocheck

import { forwardRef } from "react";

/**
 * A wrapper around `forwardRef` that adds support for namespaced properties.
 * This is useful when you want to add additional properties to a component
 *
 * @example
 * ```tsx
 * const MyComponent = namespacedForwardRef<
 * 	HTMLDivElement,
 * 	MyComponentProps,
 * 	{ Skeleton: typeof Skeleton }
 * >(function MyComponent({ children }, ref) {
 * 	 return (...)
 * }
 *
 * MyComponent.Skeleton = function Skeleton() {
 *	return <div className="skeleton" />
 * }
 * ```
 */
export function namespacedForwardRef<El, Props = unknown, NamespacedProperties = Record<string, unknown>>(
	args: React.ForwardRefRenderFunction<El, Props>
) {
	return forwardRef<El, Props>(args) as React.ForwardRefExoticComponent<
		React.PropsWithoutRef<Props> & React.RefAttributes<El>
	> &
		NamespacedProperties;
}
